import { useState } from 'react';

export const useCampaignExpansion = (campaignIds = []) => {
  const [expandedCampaign, setExpandedCampaign] = useState(null);

  const toggleCampaign = (campaignId) => {
    setExpandedCampaign((prev) => (prev === campaignId ? null : campaignId));
  };

  const expandAll = () => {
    // For single expansion, we'll expand the first campaign
    if (campaignIds.length > 0) {
      setExpandedCampaign(campaignIds[0]);
    }
  };

  const collapseAll = () => {
    setExpandedCampaign(null);
  };

  const isExpanded = (campaignId) => {
    return expandedCampaign === campaignId;
  };

  return {
    expandedCampaign,
    toggleCampaign,
    expandAll,
    collapseAll,
    isExpanded,
  };
};
